<template>
  <div class="body">
    <to-buy
      v-show="pageIndex === 0"
      @toBuy="toPay"
    ></to-buy>
    <topay
      ref="topay"
      v-show="pageIndex === 1"
    ></topay>
  </div>
</template>
<script>
import mainPage from './modules/main'
import toBuy from './modules/to-buy'
import setAddressBox from './modules/set-address'
import topay from './modules/topay'
export default {
  data () {
    return {
      pageIndex: 0
    }
  },
  components: {
    mainPage,
    toBuy,
    setAddressBox,
    topay
  },
  created () {
    this.init()
  },
  methods: {
    init (index) {
      if (!index) {
        this.pageIndex = 0
      }
    },
    toPay () {
      this.$refs.topay.init()
      this.pageIndex = 1
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/agentBuy/index.vue